import { fontType, main } from '../assets/extras'
import './styles/addteacher.css'

const AddTeacher = ({addTeacher, setAddTeacher, onHandleAdd, sedes = []}) => {
    return (
        <div className='mainAddTeacher' style={{
            animation: addTeacher.show === true ? "showOn 0.5s linear forwards" : 
            "showOff 0.5s linear forwards",
            display: addTeacher.show === false ? "none" : "flex",
            zIndex: 1000
        }}>
            <div className='addTeacherCont' style={{
                fontFamily: fontType.text
            }}>
                <p style={{
                    marginBottom: 20,
                    borderBottom: "1px solid black",
                    width: "100%",
                    paddingBottom: "10px",
                    textAlign: "center",
                    fontFamily: fontType.title,
                    fontSize: 25
                }}>AGREGAR PROFESOR</p>
                <div className='contInput'>
                    <p>Nombre</p>
                    <input
                        value={addTeacher.nombre_profesor}
                        maxLength={20}
                        onChange={e => {
                            const t = e.target.value

                            setAddTeacher(prev => ({
                                ...prev,
                                nombre_profesor: t.trim()
                            }))
                        }}
                    />
                </div>
                <div className='contInput'>
                    <p>Apellido paterno</p>
                    <input
                        value={addTeacher.apellido_p_profesor}
                        maxLength={25}
                        onChange={e => {
                            const t = e.target.value

                            setAddTeacher(prev => ({
                                ...prev,
                                apellido_p_profesor: t.trim()
                            }))
                        }}
                    />
                </div>
                <div className='contInput'>
                    <p>Correo</p>
                    <input
                        value={addTeacher.correo_profesor}
                        maxLength={50}
                        onChange={e => {
                            const t = e.target.value

                            setAddTeacher(prev => ({
                                ...prev,
                                correo_profesor: t.trim().toLowerCase()
                            }))
                        }}
                    />
                </div>
                <div className='contInput'>
                    <p>Clave</p>
                    <input
                        value={addTeacher.clave_profesor}
                        disabled={true}
                        style={{
                            color: "#aaa"
                        }}
                    />
                </div>
                {sedes.length > 1 && (
                    <div className='contInput'>
                        <p style={{ marginTop: 10 }}>Sedes asignadas</p>
                        {sedes.map(s => (
                            <label key={s.id} style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 3, cursor: "pointer" }}>
                                <input
                                    type="checkbox"
                                    checked={(addTeacher.sedes_seleccionadas || []).includes(s.id)}
                                    onChange={e => {
                                        const checked = e.target.checked
                                        setAddTeacher(prev => {
                                            const current = prev.sedes_seleccionadas || []
                                            return {
                                                ...prev,
                                                sedes_seleccionadas: checked
                                                    ? [...current, s.id]
                                                    : current.filter(id => id !== s.id)
                                            }
                                        })
                                    }}
                                />
                                {s.nombre_sede}
                            </label>
                        ))}
                    </div>
                )}
                <div className='contButtons'>
                    <button style={{
                        cursor: "pointer",
                        border: "none",
                        width: "120px",
                        height: 40,
                        marginRight: 10,
                        background: "none",
                        fontFamily: fontType.subTitle
                    }} onClick={() => {
                        setAddTeacher(prev => ({
                            ...prev,
                            show: false
                        }))
                    }}>CANCELAR</button>
                    <button style={{
                        cursor: "pointer",
                        border: "none",
                        width: "120px",
                        height: 40,
                        marginRight: 10,
                        backgroundColor: main,
                        color: "white",
                        fontFamily: fontType.subTitle,
                        borderRadius: 10
                    }} onClick={onHandleAdd}>AGREGAR</button>
                </div>
            </div>
        </div>
    )
}

export default AddTeacher